import React from 'react';
import { JobsiteAnnouncement } from 'apollo/generated/client-operations';
import { RecipientCountsProps } from './constants';
import { AnnouncementSection } from './AnnouncementSection';
import { RecipientCounts } from './RecipientCounts';

export function AnnouncementPerformance({
  counts,
  announcement,
}: {
  announcement: Partial<JobsiteAnnouncement>;
  counts: RecipientCountsProps['counts'];
}): React.ReactElement {
  return (
    <AnnouncementSection id="performance" title="Performance">
      <RecipientCounts counts={counts} announcement={announcement} />
    </AnnouncementSection>
  );
}
